exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ExtraButtons .popover-trigger-button{width:auto\n}\n.ExtraButtons .popover-trigger{position:static;padding:10px;margin:-10px\n}\n.ExtraButtons .popover-trigger:hover .svg-inline--fa{color:#b9b9ba;color:var(--text, #b9b9ba)\n}", ""]);

// exports
